import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * user API
 * @author Yang
 */
export default {
  /**
   * [getFrameEventInfoList 이벤트 정보를 조회한다.]
   * @author {Yang}
   */
  getEventStatusOfPhysical(params) {
    return axios.post(`${baseUrl}/frame/event/get-event-status-of-physical.do`, params);
  },
  getEventStatusCountOfPhysical(params) {
    return axios.get(`${baseUrl}/frame/event/get-event-status-count-of-physical.do`, params);
  },
  getPredictEventCount(params) {
    return axios.get(`${baseUrl}/frame/event/get-predict-event-count.do`, params);
  },
  getPredictEventList(params) {
    return axios.post(`${baseUrl}/frame/event/get-predict-event-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/frame/event.js